// These are local variables for sidebar states
export const DASHBOARD_PAGE = "dashboard";
export const CUSTOMER_LIST_PAGE = "customers";
export const CUSTOMER_PROFILE_PAGE = "customers_profile";
export const EMPLOYEES_PAGE = "users";
export const FINANCIAL_PAGE = "finance";
export const FORMS_PAGE = "forms";
export const FORM_SUBMIT_PAGE = "form-submit";
export const FORM_EDIT_PAGE = "form_edits";
export const DOCUMENTS_PAGE = "files";
export const CANDIDATE_PROFILE_CREATION = "profile creation";
export const CANDIDATE_PROFILE_CREATION_AI = "profile creation ai";
export const CANDIDATE_SHORT_LIST = "short list";
export const LEAD_LIST_PAGE = "lead list";
export const JOB_ORDERS_PAGE = "job-orders";
export const INQUIRY_LIST_PAGE = "inquiry-list";
export const SYSTEM_CONFIGS_PAGE = "system-config";
export const FRONT_OFFICE_PAGE = "front-office";
export const CVDATA_PAGE = "cv-data";
export const CLIENT_PAGE = "client-portal";
export const  CANDIDATE_PAGE = "candidate-portal";
export const CANDIDATE_HOME_PAGE = "candidate-home";
export const CLIENT_HOME_PAGE = "client-home";
export const REPORTS_PAGE = "reports";